import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { AuthenticationError } from '../../../../api/requests/tuitionProcess';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { useStudentCurrentAccountLoader } from '../../components/StudentCurrentAccountLoader';
import { getDebts } from '../api';
import { DebtRsponse } from '../types';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  DebtRsponse,
  AuthenticationError | AxiosResultDefaultError
>();

export function useDebtLoader() {
  return useFetch();
}

export const debtLoaderConsumer = FetchConsumer;

export default function DebtLoader({ children }: BaseLoaderProps) {
  const { data } = useStudentCurrentAccountLoader();
  const request = useCallback(async () => {
    return getDebts(data.studentId);
  }, [data.studentId]);
  return (
    <FetchProvider
      request={request}
      defaultQuery={undefined}
      fetchImmediately={true}
    >
      <FetchConsumer>
        {({ loading, data, error, refresh }) => {
          if (loading) {
            return <Loading insideCard />;
          } else if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
              />
            );
          } else if (data) {
            return children;
          } else {
            return null;
          }
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
